define([
	"dojo/_base/declare",
	"csi/action/Controller"
], function(declare,Controller) {

	return declare([Controller], {
		addProxyActions: function(/*View*/defView, /*Actions*/defActions) {
			// summary: add submit action
			defActions.addAction(this.getProxyAction("BUTTON_SET_PRODUCTION_QUOTE", false, {m_bSubmit: true}));
			this.inherited(arguments);
		}
	});
});
